import React from 'react';
import {View} from 'react-native-web';
import {TableHeader} from 'src/components/header/TableHeader';
import {transitionalEventStyle} from './style/transitionalEventTable.style';
import {BasicTable} from 'src/components/table/Table';
import {routeLink} from 'src/constant';
import {FilePreviewer} from 'src/components/filePreviewer';

const CCDDocuments = ({encounter}) => {
  return (
    <View style={transitionalEventStyle.containerView}>
      <TableHeader title={'CCD Documents'} />
      <BasicTable
        api={routeLink.ccdLogs}
        fields={{
          fileName: 1,
          file: 1,
          createdAt: 1,
          status: 1,
        }}
        filter={{
          encounterId: encounter?._id,
        }}
        sort={{
          createdAt: -1,
        }}
        variant={'outline'}
        columns={[
          {
            header: 'Document Name',
            field: 'fileName',
            type: 'text',
          },
          {
            render: FilePreviewer,
            width: 50,
            field: 'file',
          },
        ]}
      />
    </View>
  );
};

export default CCDDocuments;
